import React, { useState } from "react";
import { db } from "./firebase";
import {
    doc,
    getDoc,
    updateDoc,
    deleteDoc,
    getDocs,
    collection
} from "firebase/firestore";

const PIN = "5459";

function Admin() {
    const [input, setInput] = useState("");
    const [authorized, setAuthorized] = useState(false);
    const [loading, setLoading] = useState(false);

    const configRef = doc(db, "config", "voting");

    const handleAccess = (e) => {
        e.preventDefault();
        if (input === PIN) {
            setAuthorized(true);
        } else {
            alert("❌ PIN incorrecto");
            setInput("");
        }
    };

    const handleIncreaseVersion = async () => {
        const confirm = window.confirm("¿Quieres subir la versión de votación? Los usuarios podrán volver a votar.");
        if (!confirm) return;

        setLoading(true);
        try {
            const configSnap = await getDoc(configRef);
            if (configSnap.exists()) {
                const data = configSnap.data();
                const current = data.votingVersion ?? 1;
                await updateDoc(configRef, { votingVersion: current + 1 });
                alert(`✅ Versión de votación actualizada a ${current + 1}`);
            }
        } catch (error) {
            console.error("Error al subir la versión de votación:", error);
            alert("❌ No se pudo subir la versión");
        }
        setLoading(false);
    };

    const setVotingEnabled = async (enabled) => {
        await updateDoc(configRef, { isVotingEnabled: enabled });
        alert(`✅ Votación ${enabled ? "activada" : "desactivada"}`);
    };

    const handleResetVotes = async () => {
        const confirm = window.confirm("¿Estás seguro de que quieres borrar todos los votos?");
        if (!confirm) return;

        setLoading(true);
        try {
            const snapshot = await getDocs(collection(db, "votes"));
            const deletes = snapshot.docs.map((docu) => deleteDoc(docu.ref));
            await Promise.all(deletes);
            alert("✅ Votos eliminados");
        } catch (error) {
            console.error("Error eliminando votos:", error);
            alert("❌ Error al eliminar los votos");
        }
        setLoading(false);
    };

    if (!authorized) {
        return (
            <div style={{ textAlign: "center", marginTop: "5rem" }}>
                <h2>Introduce PIN de administrador</h2>
                <form onSubmit={handleAccess}>
                    <input
                        type="password"
                        maxLength={4}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        style={{
                            fontSize: "2rem",
                            width: "6rem",
                            textAlign: "center",
                            letterSpacing: "0.4rem",
                            padding: "0.5rem"
                        }}
                        autoFocus
                    />
                    <br />
                    <button style={{ marginTop: "1rem" }}>Acceder</button>
                </form>
            </div>
        );
    }

    return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
            <h1>Panel de administración</h1>

            <button onClick={() => setVotingEnabled(true)}>✅ Activar votación</button>
            <br />
            <button
                onClick={() => setVotingEnabled(false)}
                style={{ marginTop: "1rem" }}
            >
                🛑 Desactivar votación
            </button>
            <br />
            <button
                onClick={handleResetVotes}
                style={{
                    marginTop: "2rem",
                    backgroundColor: "#f44336",
                    color: "white",
                    padding: "0.6rem 1.2rem"
                }}
                disabled={loading}
            >
                🗑️ Resetear votos
            </button>
            <br />
            <button
                onClick={handleIncreaseVersion}
                style={{
                    marginTop: "2rem",
                    backgroundColor: "#6a1b9a",
                    color: "white",
                    padding: "0.6rem 1.2rem"
                }}
                disabled={loading}
            >
                🔁 Subir versión de votación
            </button>

        </div>
    );
}

export default Admin;
